import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Inspection, InspectionSection, InspectionPoint, InspectionFolder } from '../../shared/models/index';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'section-detail',
    templateUrl: './detail.component.html',
    standalone: false
})
export class SectionDetailComponent implements OnInit {
  @Input() public section: InspectionSection;
  @Input() public points: InspectionPoint[];
  @Input() public folders: InspectionFolder[];
  @Input() public inspection: Inspection;
  @Input() public inspectionId: string;
  @Input() public query = '';
  @Output() public toggleOpenPoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleOpenFolder: EventEmitter<any> = new EventEmitter();

  @Output() public toggleSelectPoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleSelectFolder: EventEmitter<any> = new EventEmitter();

  private isEditRoute = false;

  errorMessage: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.url.subscribe((urlPaths) => {
      this.isEditRoute = urlPaths[0] && urlPaths[0].path === 'edit';
    });
  }

  public openPoint(point: InspectionPoint) {
    this.toggleOpenPoint.emit(point);
  }

  public selectPoint(point: any) {
    this.toggleSelectPoint.emit(point);
  }

  public selectFolder(folder: any) {
    this.toggleSelectFolder.emit(folder);
  }

  public openFolder(folder: InspectionFolder) {
    this.toggleOpenFolder.emit(folder);
  }

  public editRouteFor(id: string) {
    return [environment.applicationRoute + '/inspections', id, this.isEditRoute ? '' : 'edit'];
  }
}
